import {
  Button,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
  VStack,
} from '@chakra-ui/react';
import { SessionReminderModal } from '@web-app/components/SessionReminderModal';
import React, { useEffect } from 'react';

const DiabetesOrPrediabetesTemplateUsageReminderModal: React.FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  // Auto-open the modal when component mounts
  useEffect(() => {
    onOpen();
  }, [onOpen]);

  const handleCompleted = () => {
    onClose();
  };

  return (
    <SessionReminderModal
      popupId="diabetes-or-prediabetes-reminder"
      isOpen={isOpen}
      onClose={onClose}
      size="md"
    >
      <ModalOverlay />
      <ModalContent bg="bg.default" color="text.default">
        <ModalHeader>⚠️ Diabetes or Prediabetes Patient Flag</ModalHeader>

        <ModalBody>
          <VStack spacing={4} align="start">
            <Text>
              This patient has selected Diabetes or Prediabetes in visit
              reasons.
            </Text>
            <Text>
              We recommend selecting the &quot;
              <strong>Diabetes MNT</strong>&quot; template to guide your
              session.
            </Text>
          </VStack>
        </ModalBody>

        <ModalFooter>
          <VStack spacing={2} w="full">
            <Button colorScheme="blue" onClick={handleCompleted} w="full">
              Got it!
            </Button>
            <Button variant="ghost" onClick={onClose} size="sm">
              Close
            </Button>
          </VStack>
        </ModalFooter>
      </ModalContent>
    </SessionReminderModal>
  );
};

export default DiabetesOrPrediabetesTemplateUsageReminderModal;
